module.exports = __webpack_public_path__ + "img/uk-liver-cancer-female.be1ba295.png";